// @flow
export const SHOW_MESSAGE: 'material-ui/snackbar/SHOW_MESSAGE' =
  'material-ui/snackbar/SHOW_MESSAGE';
export const SHOW_NEXT_MESSAGE: 'material-ui/snackbar/SHOW_NEXT_MESSAGE' =
  'material-ui/snackbar/SHOW_NEXT_MESSAGE';
export const OPEN: 'material-ui/snackbar/OPEN' = 'material-ui/snackbar/OPEN';
export const CLOSE: 'material-ui/snackbar/CLOSE' = 'material-ui/snackbar/CLOSE';
